export const Messages = {
  CANNOT_DELETE_ASSIGNMENT_PRODUCT_INVALID_STATUS:
    "Produsul nu poate fi șters - statusul achiziției nu permite ștergerea.",
};
